import {
  CONTENT_TYPES,
  CONTENT_TYPE_LABELS,
  type ContentType,
} from "../../../services/webServices/banners/types";

type BannerTypeTabsProps = {
  value: ContentType;
  onChange: (value: ContentType) => void;
};

export default function BannerTypeTabs({ value, onChange }: BannerTypeTabsProps) {
  return (
    <div className="flex gap-2 p-1 bg-gray-100 rounded-xl">
      {CONTENT_TYPES.map((type) => {
        const isActive = type === value;
        return (
          <button
            key={type}
            type="button"
            onClick={() => onChange(type)}
            className={
              isActive
                ? "flex-1 py-2 px-4 rounded-lg text-sm font-medium text-primaryVar-600 bg-white shadow-sm"
                : "flex-1 py-2 px-4 rounded-lg text-sm font-medium text-gray-600 hover:text-gray-800 hover:bg-gray-50"
            }
          >
            {CONTENT_TYPE_LABELS[type]}
          </button>
        );
      })}
    </div>
  );
}
